import type { AppState } from 'types/app';

export const selectOutfitRecos = (state: AppState) => state.outfitRecos;
